<template>
  <div class="orderBox">
    <div class="main">
      <div class="orderInfoBox">
        <div class="orderInfo">
          <p class="name ellipsis">
            {{ ordertype == 1004 ? orderInfo.name : orderInfo.productname }}
          </p>
          <p
            class="title"
            v-if="orderInfo"
          >{{ switchTitle() }}</p>
          <p class="price"><em>¥ </em>{{ util.toFixed(totalPrice, 2) }}</p>
        </div>
        <div
          class="common account"
          v-if="userinfo && userinfo.mobilenumber"
        >
          <p class="title">支付账号</p>
          <div class="commonContent">
            <span class="ellipsis Left haveData">{{
              userinfo.nickname +
              "（" +
              (userinfo.mobilenumber.slice(0, 3) +
                "****" +
                userinfo.mobilenumber.slice(7, 11)) +
              "）"
            }}</span>
          </div>
        </div>
        <div
          class="common coupons"
          v-if="coursetype!=1001&&coursetype!=1002"
        >
          <p class="title">优惠券</p>
          <div
            class="commonContent"
            @click="chooseDiscount()"
          >
            <span :class="['ellipsis', 'Left', couponInfo ? 'haveData' : '']">
              {{ couponInfo ? "- ¥" +discountPrice : coupons.length + "张可用" }}</span>
            <span
              class="Right"
              v-if="coupons.length > 0"
            >查看</span>
          </div>
        </div>
        <div class="common payType">
          <p class="title">支付方式</p>
          <div class="commonContent">
            <ul>
              <li
                v-for="(item, index) in payType"
                :key="index"
              >
                <div class="type">
                  <i :class="item.className"></i><span>{{ item.name }}</span>
                </div>
                <i :class="payindex == index ? 'active' : ''"></i>
              </li>
            </ul>
            <div
              class="vipBox"
              v-if="(ordertype == 1000 || ordertype == 1012) && vipInfo"
            >
              <div class="info">
                <p class="tip">开通{{ orderInfo.sclassname }}VIP</p>
                <p class="text">免费畅学全部{{ orderInfo.sclassname }}类课程</p>
              </div>
              <div
                class="opation"
                @click="goVip()"
              >
                <span>去开通</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buyTip common">
        <p class="title">购买说明</p>
        <div class="commonContent">
          <ul>
            <li>1、购买课程为虚拟内容服务，不支持退款、转让、退换；</li>
            <li>2、购买后可在学习中心查看并学习。</li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="footerBox"
      ref="footer"
    >
      <div
        class="price"
        @click="bottom ? (showToast = !showToast) : ''"
      >
        <em>实付</em>
        <span>¥{{  util.toFixed(payPrice,2) }}</span>
        <i :class="showToast ? 'active' : ''"></i>
      </div>
      <div
        class="next"
        @click="pay()"
      >确认支付</div>
    </div>
    <div
      :class="[showToast ? '' : 'hideBox', 'newToastBox']"
      :style="{ bottom: bottom + 'px' }"
    >
      <div :class="[showToast ? '' : 'hideContent', 'toastContent']">
        <div class="content">
          <ul>
            <li>
              <span class="title">总价</span>
              <span class="price">{{
                "¥ " + util.toFixed(totalPrice, 2)
              }}</span>
            </li>
            <li v-if="coursetype!=1001&&coursetype!=1002">
              <span class="title">优惠券抵扣</span>
              <span class="price">{{"-¥ " +discountPrice}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Toast
      :toastData="toast"
      :show="showToast1"
      v-on:toastCallBack="toastCallBack"
    ></Toast>
  </div>
</template>

<script>
/* ordertype = 订单类型参数如下
      1000:商品课程类型,1002:商品评卷类型,1004:商品活动类型,
1006:商品实物类型,1008:商品预约大师类型,1010:商品视频组合套餐类型,
1012:商品课程组合套餐类型:大类1014中类1016小类1018全站1020,2000综合订单
1022:陪练，1024:一对一，1026:小班课 */
import Toast from "@/components/toast";
export default {
  name: "order",
  metaInfo: {
    title: "确认订单",
  },
  data() {
    return {
      ordertype: "",
      orderInfo: "",
      productid: "",
      price: "",
      buyNum: 1,
      userinfo: {},
      coupons: [],
      couponInfo: "",
      couponIndex: -1,
      totalPrice: "",
      payPrice: '0',
      discountPrice: 0,
      showToast: false,
      vipInfo: "",
      payType: [{ className: "wechat", name: "微信支付" }],
      payindex: 0,
      bottom: "",
      tickettype: { 1000: "单人票", 1001: "双人情侣票", 1002: "三人家庭票" },
      coursetype: "", //1000课程 1001 秒杀 1002 团购 1003套餐 1004拼团参团  针对秒杀以及团购的商品区分
      courseid: "",
      showToast1: false,
      toast: "",
    };
  },
  components: {
    Toast,
  },
  watch: {
    ['couponInfo']() {
      var couponInfo = this.couponInfo;
      if (couponInfo) {
        if (couponInfo.goodsdiscounttype == 1001) {
          this.discountPrice = this.util.toFixed(couponInfo ? couponInfo.discountamount : 0, 2)
        } else if (couponInfo.goodsdiscounttype == 1002) {
          this.discountPrice = (this.totalPrice * (couponInfo.discountamount * 0.01)).toFixed(2)
        }
      } else {
        this.discountPrice = 0
      }

      var payPrice = this.totalPrice - this.discountPrice;
      this.payPrice = payPrice > 0 ? payPrice : 0;
    }
  },
  mounted() {
    var _this = this;
    this.ordertype = this.$route.query.ordertype
      ? this.$route.query.ordertype
      : "";
    this.productid = this.$route.query.productid
      ? this.$route.query.productid
      : "";
    this.coursetype = this.$route.query.coursetype
      ? this.$route.query.coursetype
      : "";
    this.courseid = this.$route.query.courseid
      ? this.$route.query.courseid
      : "";
    this.buyNum = this.$route.query.buyNum ? this.$route.query.buyNum : 1;
    this.userinfo = JSON.parse(
      JSON.stringify(_this.$store.state.state.userinfo)
    );
    this.getOrderInfo();
  },
  methods: {
    toastCallBack(e) {
      var type = e.type;
      var data = e.data;
      switch (type) {
        case "close":
          break;
        case "submit":
          if (data) {
            if (data.type == "discount") {
              this.couponInfo = data.discountInfo;
            }
          }
          break;
        default:
          break;
      }
      this.showToast1 = false;
    },
    switchTitle() {
      var ordertype = this.ordertype;
      var orderInfo = this.orderInfo;
      if (ordertype == 1000) {
        return (
          orderInfo.teachername +
          " · " +
          orderInfo.lessoncount +
          "讲 · 有效期：" +
          orderInfo.learning +
          "天"
        );
      } else if (ordertype == 1010 || ordertype == 1012) {
        return (
          orderInfo.coursecount +
          "门课 · " +
          orderInfo.videocount +
          "讲 · 有效期：" +
          orderInfo.learning +
          "天"
        );
      } else if (ordertype == 1004) {
        return (
          this.util.changeTime({
            time: orderInfo.activityevens[0].eventenddate,
            showWeek: true,
            showMin: true,
          }) +
          " · " +
          this.tickettype[orderInfo.activityprices[0].tickettype] +
          " · " +
          this.buyNum +
          "张"
        );
      } else if (
        ordertype == 1031 ||
        ordertype == 1032 ||
        ordertype == 1033 ||
        ordertype == 1034
      ) {
        return orderInfo.subtitle;
      }
    },
    getOrderInfo() {
      var _this = this;
      var url = "",
        obj = {};
      switch (this.ordertype - 0) {
        case 1004:
          url = "/iart-api-scm/api/scm/activity/queryByActivityDetail";
          obj = { productid: this.productid };
          break;
        case 1028:
          url = "/iart-api-scm/api/scm/activity/queryActivityByProduct";
          obj = { productid: this.productid };
          break;
        case 1012:
        case 1010:
        case 1000:
          url = "/iart-api-scm/api/scm/product/queryproducts";
          obj = { productid: this.productid, productcategory: this.ordertype };
          break;
        case 1031:
        case 1032:
        case 1033:
        case 1034:
          url = "/iart-api-scm/api/scm/product/queryVIPProductForBuy";
          obj = { productid: this.productid };
          break;
        default:
          break;
      }
      if (url) {
        this.$post(url, obj).then((res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              this.orderInfo = res.data;
              this.price = res.data.sellprice;
              if (this.ordertype == 1004) {
                this.price = this.orderInfo.activityprices[0].sellingprice;
              } else if (this.ordertype == 1028) {
                this.price = res.data.price;
              } else if (this.ordertype == 1000 || this.ordertype == 1012 || this.ordertype == 1010) {
                if (this.coursetype == 1002 || this.coursetype == 1004) {
                  this.price = res.data.groupprice;
                } else if (this.coursetype == 1001) {
                  this.price = res.data.flashsaleprice;
                }
                this.getVip();
              }
              this.totalPrice = this.price * this.buyNum;
              this.payPrice = this.price * this.buyNum;
              if (this.coursetype != 1001 && this.coursetype != 1002) {
                this.getCoupons(this.totalPrice);
              }
              setTimeout(() => {
                _this.bottom = _this.$refs.footer.offsetHeight;
              }, 300);
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        });
      }
    },
    getCoupons() {
      var obj = {
        products: [
          {
            productid: this.productid,
            quantity: this.buyNum,
          },
        ],
      };
      this.$post("/iart-api-oaf/api/oaf/customer/queryPromotion", obj).then(
        (res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              var data = res.data;
              this.coupons = data ? data : [];
              if (data.length > 0) {
                this.couponInfo = data[0];
              }
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        }
      );
    },
    getVip() {
      var obj = {
        businesstype: 1018,
        lclasscode: this.orderInfo.lclasscode,
        mclasscode: this.orderInfo.mclasscode,
        sclasscode: this.orderInfo.sclasscode,
      };
      this.$post("iart-api-crm/api/crm/custservice/queryCustVipAd", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.vipInfo =
                res.data && res.data.buyStatus != "Y" ? res.data : "";
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    pay() {
      var _this = this,
        url = "";
      var obj = {
        ordertype: this.ordertype,
        details: [
          {
            productid: this.productid,
            quantity: this.buyNum,
          },
        ],
        payment: { paymentmode: 1007, subpaymode: 1003 },
      };
      if (this.ordertype == 1004) {
        obj.details[0].ticket = {
          tickettype: this.orderInfo.activityprices[0].tickettype,
        };
      }
      if (this.couponInfo) {
        obj.discount = [
          {
            promotionid: this.couponInfo.promotionid,
            customercouponid: this.couponInfo.customercouponid,
          },
        ];
      }
      switch (this.coursetype - 0) {
        case 1002:
          obj.promotiongroupdkuid = this.courseid;
          url = "/iart-api-crm/api/crm/promotiongroup/oneKeyBeginGroup";
          break;
        case 1004:
          obj.ordergroupheadid = this.courseid;
          url = "/iart-api-crm/api/crm/promotiongroup/friendsJoinGroup";
          break;
        case 1001:
          obj.flashsaleskuid = this.courseid;
          url = "/iart-api-crm/api/crm/flashsale/createByMqOrder";
          break;
        default:
          url = "/iart-api-oaf/api/oaf/customer/order";
          break;
      }
      this.util.showLoading();
      this.$post(url, obj).then((res) => {
        this.util.hideLoading();
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              if (res.data.totalactualprice <= 0) {
                this.$router.replace({
                  path: "/h5/common/paySuccess",
                  query: {
                    orderType: this.ordertype,
                    orderId: res.data.orderid,
                  },
                });
              } else {
                this.$post("/iart-api-pay/wx/pay", {
                  orderid: res.data.orderid,
                  tradetype: "JSAPI",
                })
                  .then((resPay) => {
                    if (resPay.code == 1) {
                      var data = resPay.data;
                      wx.ready(function () {
                        wx.chooseWXPay({
                          appId:data.appid,
                          timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                          nonceStr: data.nonce_str, // 支付签名随机串，不长于 32 位
                          package: "prepay_id=" + data.prepayId, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                          paySign: data.paysign, // 支付签名
                          success: function (resPaySuccess) {
                            // 支付成功后的回调函数
                            if (resPaySuccess.errMsg == "chooseWXPay:ok") {
                              if (
                                _this.coursetype == 1002 ||
                                _this.coursetype == 1004
                              ) {
                                _this.$router.replace({
                                  path: "/h5/course/groupDetail",
                                  query: {
                                    ordergroupheadid: res.data.ordergroupheadid,
                                  },
                                });
                              } else {
                                _this.$router.replace({
                                  path: "/h5/common/paySuccess",
                                  query: {
                                    orderType: this.ordertype,
                                    orderId: res.data.orderid,
                                  },
                                });
                              }
                            }
                          },
                          cancel: function (resPayFail) {
                            _this.$router.replace({
                              path: "/h5/mine/order/orderDetail",
                              query: { orderId: res.data.orderid },
                            });
                          },
                        });
                      });
                    } else {
                      this.util.toast({ msg: resPay.message });
                    }
                  })
                  .catch((res) => { });
              }
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
    chooseDiscount() {
      if (this.coupons.length > 0) {
        this.showToast1 = true;
        this.toast = {
          title: "优惠券",
          btnText: "不使用优惠券",
          type: "discount",
          background: "#fff",
          list: this.coupons,
          couponInfo: this.couponInfo,
          btnClass: 'default'
        };
      }
    },
    goVip() {
      this.$router.push({
        path: "/h5/index/vip/sVipDetail",
        query: {
          certificatemasterid: this.vipInfo.certificatemasterid,
          certificaruleid: this.vipInfo.parentidruleid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.orderBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    margin: 16px;
    overflow-x: hidden;
    .common {
      margin: 0 16px;
      padding: 16px 0 0;
      background: #fff;
      .title {
        font-size: 12px;
        line-height: 17px;
        color: rgba(53, 54, 60, 1);
        font-weight: 500;
      }
      .commonContent {
        margin-top: 8px;
      }
    }
    .common:not(:last-child) {
      border-bottom: 0.5px solid rgba(224, 224, 224, 1);
      padding-bottom: 16px;
    }
    .orderInfoBox {
      background: #fff;
      border-radius: 8px;
      padding: 24px 0;
      .orderInfo {
        margin-bottom: 6px;
        position: relative;
        border-bottom: 0.5px dashed rgba(53, 54, 60, 0.3);
        padding: 0 16px 24px;
        .name {
          font-size: 18px;
          line-height: 25px;
          color: rgba(53, 54, 60, 1);
          font-weight: bold;
        }
        .title {
          font-size: 13px;
          line-height: 18px;
          color: rgba(53, 54, 60, 1);
          margin-top: 8px;
          font-weight: 300;
          span {
            max-width: 30%;
          }
        }
        .price {
          font-size: 22px;
          line-height: 28px;
          color: rgba(53, 54, 60, 1);
          font-weight: bold;
          margin-top: 8px;
          em {
            font-size: 12px;
            line-height: 17px;
          }
        }
      }
      .orderInfo::before {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        right: -8px;
        bottom: -8px;
        background: #f4f4f7;
      }
      .orderInfo::after {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: absolute;
        left: -8px;
        bottom: -8px;
        background: #f4f4f7;
      }
    }

    .account,
    .coupons {
      .commonContent {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        line-height: 20px;
        font-weight: 300;
        .Left {
          flex: 1;
          color: rgba(53, 54, 60, 0.4);
        }
        .haveData {
          color: rgba(53, 54, 60, 1);
        }
        .Right {
          margin-left: 12px;
          color: rgba(122, 152, 182, 1);
          font-weight: 500;
        }
      }
    }
    .payType {
      .commonContent {
        ul {
          li {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            .type {
              flex: 1;
              i {
                display: inline-block;
                width: 24px;
                height: 24px;
                margin-right: 12px;
                vertical-align: middle;
              }
              i.wechat {
                background: url(../../../assets/img/h5/wechatPay.png) no-repeat;
                background-size: 24px 24px;
              }
              span {
                font-size: 14px;
                line-height: 20px;
                color: rgba(53, 54, 60, 1);
                font-weight: 300;
              }
            }
            > i {
              margin-left: 12px;
              display: inline-block;
              width: 33px;
              height: 32px;
              background: url(../../../assets/img/h5/checke.png) no-repeat;
              background-size: 33px 32px;
            }
            > i.active {
              background: url(../../../assets/img/h5/checked.png) no-repeat;
              background-size: 33px 32px;
            }
          }
          li:not(:last-child) {
            margin-bottom: 8px;
          }
        }
        .vipBox {
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          align-items: center;
          background: linear-gradient(155deg, #ddd4c5 0%, #dccfc7 100%);
          border-radius: 3px;
          padding: 16px 24px;
          .info {
            flex: 1;
            overflow: hidden;
            margin-right: 12px;
            .tip {
              font-size: 14px;
              line-height: 20px;
              color: rgba(53, 54, 60, 0.8);
              font-weight: bolder;
            }
            .text {
              font-size: 12px;
              line-height: 17px;
              color: rgba(53, 54, 60, 0.8);
              margin-top: 4px;
            }
          }
          .opation {
            span {
              display: inline-block;
              width: 60px;
              font-size: 12px;
              line-height: 17px;
              color: rgba(45, 45, 45, 0.8);
              border: 1px solid rgba(53, 54, 60, 0.8);
              border-radius: 14px;
              padding: 5px 0;
              text-align: center;
            }
          }
        }
      }
    }
    .buyTip {
      border-radius: 8px;
      margin: 0;
      padding: 16px;
      margin-top: 16px;
      ul {
        li {
          color: rgba(53, 54, 60, 0.4);
          font-size: 12px;
          line-height: 20px;
          font-weight: 400;
        }
      }
    }
  }
  .footerBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
    background: #fff;
    .price {
      em {
        font-size: 12px;
        line-height: 17px;
        color: rgba(174, 175, 177, 1);
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
        margin: 0 4px;
        font-size: 22px;
        line-height: 28px;
        color: rgba(53, 54, 60, 1);
        font-weight: bold;
      }
      i {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../assets/img/h5/triangle_d_g.png) no-repeat;
        background-size: 24px 24px;
        vertical-align: top;
        transition: all linear 0.2s;
      }
      i.active {
        transform: rotate(180deg);
        transition: all linear 0.2s;
      }
    }
    .next {
      flex: 1;
      margin-left: 40px;
      color: #ffffff;
      font-size: 14px;
      line-height: 20px;
      padding: 13px 0;
      text-align: center;
      background: rgba(201, 55, 61, 1);
      border-radius: 3px;
    }
  }
  .newToastBox {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    opacity: 1;
    z-index: 11;
    .toastContent {
      background: #fff;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      transition: all linear 0.2s;
      padding: 16px 0;
      .content {
        padding: 0 16px;
        li {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0;
          .title {
            font-size: 12px;
            line-height: 17px;
            color: rgba(53, 54, 60, 0.4);
          }
          .price {
            font-size: 14px;
            line-height: 18px;
            font-weight: bold;
            color: rgba(53, 54, 60, 1);
          }
        }
        li:not(:last-child) {
          border-bottom: 0.5px solid rgba(224, 224, 224, 1);
        }
      }
    }
    .hideContent {
      bottom: -100vh;
      transition: all linear 0.2s;
    }
  }
  .hideBox {
    transition: all linear 0.2s;
    opacity: 0;
    z-index: -1;
  }
}
</style>